import cn from 'classnames';

import styles from './Loader.module.scss';

enum Dimensions {
  DEFAULT = 50,
}

interface LoaderProps {
  width?: number;
  height?: number;
  testId?: string;
  color?: string;
  inline?: boolean;
  className?: string;
}

const Loader = ({
  width = Dimensions.DEFAULT,
  height = Dimensions.DEFAULT,
  testId = 'app-loader',
  color,
  inline = false,
  className,
}: LoaderProps) => {
  const left = `calc(50% - ${width / 2}px)`;
  const top = `calc(50% - ${height / 2}px)`;

  return (
    <div
      data-testid={testId}
      className={cn(styles.loader, className)}
      style={inline ? { display: 'inline-flex', alignItems: 'center', justifyContent: 'center' } : { top, left }}
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 100 100'
        width={`${width}px`}
        height={`${height}px`}
        preserveAspectRatio='xMidYMid'
      >
        <circle
          cx='50'
          cy='50'
          fill='none'
          strokeWidth='10'
          r='35'
          strokeDasharray='164.93361431346415 56.97787143782138'
          stroke={color ?? 'currentColor'}
        >
          <animateTransform
            attributeName='transform'
            type='rotate'
            repeatCount='indefinite'
            dur='1s'
            values='0 50 50;360 50 50'
            keyTimes='0;1'
          />
        </circle>
      </svg>
    </div>
  );
};

export default Loader;
